export interface Module {
  number: string
  title: string
  description: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Fundamentos del Feng Shui',
    description: 'Chi, circulación energética, Yin, Yang y cómo empezar a observar tu hogar.',
  },
  {
    number: '02',
    title: 'Los Cinco Elementos',
    description: 'Madera, Fuego, Tierra, Metal y Agua: colores, materiales, formas y equilibrio.',
  },
  {
    number: '03',
    title: 'Mapa Bagua',
    description: 'Descubrí las 9 áreas de tu hogar y aprendé a ubicarlas sobre tu propio plano.',
  },
  {
    number: '04',
    title: 'Potenciá cada área de tu vida',
    description:
      'Abundancia, amor, bienestar, carrera, familia, reconocimiento, creatividad y nuevos comienzos.',
  },
  {
    number: '05',
    title: 'Feng Shui habitación por habitación',
    description: 'Entrada, living, cocina, dormitorio, baño, comedor, home office, pasillos y exteriores.',
  },
  {
    number: '06',
    title: 'Objetos y elementos del hogar',
    description: 'Espejos, plantas, agua, iluminación, fotografías, muebles, ventanas y más.',
  },
  {
    number: '07',
    title: 'El poder del color',
    description: 'Qué representa cada color y cómo incorporarlo según la energía que querés trabajar.',
  },
  {
    number: '08',
    title: 'Errores frecuentes',
    description: 'Los errores de Feng Shui más comunes y alternativas prácticas para corregirlos.',
  },
  {
    number: '09',
    title: 'Feng Shui sin gastar dinero',
    description: 'Cambios concretos que podés realizar utilizando aquello que ya tenés.',
  },
  {
    number: '10',
    title: 'Tu Plan de Transformación',
    description:
      'Convertí lo aprendido en un plan personalizado para comenzar a transformar tu hogar.',
  },
]
